import React from "react";
import OrderDetailsPage from "../../components/OrderDetailsPage";

const CartSummaryPage = () => {
  return <OrderDetailsPage />;
};

export default CartSummaryPage;
